// src/features/tidsregistering/services/statistics.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/statistics';

export const tidsregistreringStatisticsAPI = {
  getAnalyse: (startDate, endDate) =>
    apiClient.get(`${BASE}/analyse`, { params: { start_date: startDate, end_date: endDate } }),
};
